import {getStore, setStore} from '@/utils/storage'

const state = {
  // 头部主菜单当前项
  headerMenuCurrentItem: '',
  // 头部主菜单当前项query
  headerMenuCurrentItemQuery: '',
  // 侧边栏展开/收起状态
  sideBarOpen: true,
  // 侧边栏菜单当前项
  sideBarMenuCurrentItem: '',
  // 侧边栏菜单当前项查询
  sideBarMenuCurrentItemQuery: '',
  // 当前区域key
  currentRegionKey: '',
  // 新接收实时事件数组
  newEvents: [],
  // 最后一次接收的事件id
  lastEventId: getStore('lastEventId') ? Number(getStore('lastEventId')) : 0,
  // 未处理告警事件（等级大于事项）数量
  unhandledAlarmEventCount: 0
}

const mutations = {
  SET_HEADER_MENU_CURRENT_ITEM: (state, currentItem) => {
    state.headerMenuCurrentItem = currentItem
  },
  SET_HEADER_MENU_CURRENT_ITEM_QUERY: (state, currentItemQuery) => {
    state.headerMenuCurrentItemQuery = currentItemQuery
  },
  SET_SIDEBAR_OPEN: (state, open) => {
    state.sideBarOpen = open
  },
  SET_SIDEBAR_MENU_CURRENT_ITEM: (state, currentItem) => {
    state.sideBarMenuCurrentItem = currentItem
  },
  SET_SIDEBAR_MENU_CURRENT_ITEM_QUERY: (state, currentItemQuery) => {
    state.sideBarMenuCurrentItemQuery = currentItemQuery
  },
  SET_CURRENT_REGION_KEY: (state, regionKey) => {
    state.currentRegionKey = regionKey
    // setStore('currentRegionKey', regionKey.toString())
  },
  APPEND_NEW_EVENTS: (state, events) => {
    state.newEvents.push(...events)
    if (state.newEvents.length > 1000) { // 数量大于1000时，移除多余元素
      state.newEvents.splice(0, state.newEvents.length - 1000)
    }
  },
  SET_LAST_EVENT_ID: (state, eventId) => {
    state.lastEventId = eventId
    setStore('lastEventId', eventId.toString())
  },
  SET_UNHANDLED_ALARM_EVENT_COUNT: (state, unhandledAlarmEventCount) => {
    state.unhandledAlarmEventCount = unhandledAlarmEventCount
  }
}

const actions = {

}

const getters = {
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js